import React, { useContext, useEffect } from 'react';

import firebase from 'firebase';

import {
    Switch,
    Route,
    Link,
    useParams,
    useRouteMatch
} from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";

import {AuthConsumer} from '../../Context/AuthContext';

import BenefitsReview from './BenefitsReview';
import PoliciesReview from './PoliciesReview';
import ReviewsReview from './ReviewsReview';

const useStyles = makeStyles((theme) => ({
    root: {
      height: "100%",
      width: "100%",
    },
    topBar: {
        width: "100%",
        height: "60px",
        backgroundColor: "black",
        display: "flex",
        justifyContent: "flex-end"
    },
    body: {
        display: "flex",
        flexDirection: "row",
        height: "100%"
    },
    leftBar: {
        width: "200px",
        minWidth: "200px",
        height: "calc(100vh - 60px)",
        backgroundColor: "#d3e2e8",
        borderRight: "1px solid gray",
    },
    mainContent: {
        flexGrow: 1,
        height: "100%",
        height: "calc(100vh - 60px)",
        backgroundColor: "white"
    },
    signOut: {
        height: "40px",
        marginTop: "auto",
        marginBottom: "auto",
        marginRight: "10px"
    }
}))

const subpages = {
    "Policies": PoliciesReview,
    "Reviews": ReviewsReview,
    "Benefits": BenefitsReview,
    "Jobs": null
}

export default function AdminHome(props) {
    const [selectedIdx, setSelectedIdx] = React.useState(0);
    let { path, url } = useRouteMatch();
    const classes = useStyles();

    console.log('path: ', path);
    console.log('url: ', url);

    // ToDo: this way, we can display a notification for the admin
    // fetch Policies
    // fetch Reviews 
    // fetch Benefits 

    const navItems = [
        {name: "Policies", active: true, Component: PoliciesReview},
        {name: "Reviews", active: true, Component: ReviewsReview},
        // {name: "Benefits", active: true, Component: BenefitsReview},
        // {name: "Jobs", active: false, Component: null},
    ]

    const setSelectedItem = (idx) => setSelectedIdx(idx);

    const selectedItem = navItems[selectedIdx];

    return (
        <AuthConsumer>
            {({signOut}) => {
                return (
                    <div className={classes.root}>
                        <div className={classes.topBar}>This is the top bar 
                            <button className={classes.signOut} onClick={() => firebase.auth().signOut()}>Sign Out</button>
                        </div>
                        <div className={classes.body}>
                            <div className={classes.leftBar}>
                                <SideBar navItems={navItems} selectedItem={selectedItem} changeItem={setSelectedIdx} />
                            </div>
                            <div className={classes.mainContent}>
                                <Switch>
                                    <Route exact path={`${path}/`}>
                                        <PoliciesReview />
                                    </Route>
                                    <Route path={`${path}/:subpage`}>
                                        <SubPage setSelectedItem={setSelectedItem} />
                                    </Route>
                                </Switch>
                            </div>
                        </div>
                    </div>
                )
            }}
        </AuthConsumer>
    )
}

function SubPage({ setSelectedItem }) {
    const { subpage } = useParams();
    const CurrentSubpage = subpages[subpage];

    useEffect(() => {
        let i = 0;
        for (const key in subpages) {
            if (subpage === key) {
                break;
            }
            i++;
        }
        setSelectedItem(i);
    })

    return <CurrentSubpage />
}

const sidebarStyles = makeStyles((theme) => ({
    leftBarWrapper: {
        backgroundColor: "gray"
    },
    navItem: {
        height: "60px",
        backgroundColor: "lightgray",
        cursor: "pointer",
        paddingLeft: "20px",
        display: "flex",
        alignItems: "center",
        borderBottom: "1px solid gray",
        "&:hover": {
            opacity: "0.5"
        }
    },
}))

function SideBar(props) {
    const classes = sidebarStyles();
    // submissions, reviews (we should add benefits to this page)
    // we're going to make jobs active 
    const { url } = useRouteMatch();

    const { navItems, selectedItem, changeItem } = props;
    return (
        <div className={classes.leftBarWrapper}>
            {navItems.map((item, idx) => {

                const currentStyle = selectedItem.name === item.name ? { backgroundColor: "darkblue", color: "white" } : {};
                const activeStyle = item.active ? {} : { cursor: "not-allowed" };

                return (
                    <Link to={`${url}/${item.name}`}>
                        <div className={classes.navItem} style={{...currentStyle, ...activeStyle }} onClick={() => item.active ? changeItem(idx) : null}>
                            {item.name}
                        </div>
                    </Link>
                )
            })}
        </div>
    )
}